import React from 'react';
import Layout from '../layout/Main';

export default () => (
  <Layout>
    <div style={{display: 'flex', justifyContent: 'center', flexDirection:'column', alignItems: 'center', height: '250px'}}>
      <h1 style={{color: 'red', fontWeight:'bold', fontSize: '50px'}}>404</h1>
      <h3>Sorry, the page not found </h3>
    </div>
  </Layout>
);